import { render, staticRenderFns } from "./StreamDetail.vue?vue&type=template&id=0368b0de&scoped=true"
import script from "./StreamDetail.vue?vue&type=script&lang=js"
export * from "./StreamDetail.vue?vue&type=script&lang=js"
import style0 from "./StreamDetail.vue?vue&type=style&index=0&id=0368b0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0368b0de",
  null
  
)

export default component.exports